module.exports = __webpack_public_path__ + "img/rock-big-15.4dbc677e.png";